/**
 * Affiliate Gating — KHS UpPromote Integration
 *
 * Runs deferred (loaded before </body> in layout/theme.liquid).
 *
 * Responsibilities:
 *  1. Capture ?sca_ref= URL param → write uppromote_ref first-party cookie.
 *     This must run for ALL visitors (including guests) because the most common
 *     flow is: guest lands via referral link -> logs in via email + OTP ->
 *     Shopify creates the customer record. If cookie capture were gated behind
 *     a logged-in check the cookie would never be set during the initial visit.
 *
 *  2. Classify visitor by referral state (runs for all non-B2B, non-affiliated
 *     visitors). Per Section 2.2 of the implementation brief:
 *       - Guest + cookie present  → body.customer-referred
 *           (purchase still blocked by body.customer-guest CSS rules)
 *       - Logged-in + cookie      → body.customer-referred  (full access)
 *       - Logged-in + no cookie   → body.customer-gated     (no access)
 *       - B2B / affiliated        → early return (server-side authoritative)
 *
 * Server-side body classes (set by Liquid in layout/theme.liquid body tag):
 *   customer-guest       — visitor is not logged in
 *   customer-logged-in   — visitor is logged in (always with one of below)
 *   customer-b2b         — logged in + Shopify B2B practitioner
 *   customer-affiliated  — logged in + has 'affiliated-customer' tag
 *
 * JS-added body classes (this file):
 *   customer-referred    — uppromote_ref cookie present (guest or logged-in)
 *   customer-gated       — logged in + no cookie, no tag, not B2B
 *
 * Additional body class (set synchronously by snippets/customer-gate.liquid):
 *   is-logged-in         — authorised logged-in customer (B2B, affiliated, or
 *                          referred); drives [data-price-gate]/[data-atc-button]
 *                          CSS without depending on deferred JS timing
 *
 * Cookie spec:
 *   Name     : uppromote_ref
 *   Value    : URL-encoded sca_ref parameter value
 *   Path     : /
 *   Expires  : 30 days (matches UpPromote's default attribution window)
 *   SameSite : Lax
 *   Secure   : true (Shopify storefronts are always HTTPS in production)
 */

(function () {
  var STORAGE_KEY = 'uppromote_ref';

  // Step 1: Capture referral param and persist it in both cookie and
  // localStorage. Using two storage mechanisms guards against browsers that
  // clear JS-set cookies during cross-domain login redirects (e.g. Safari ITP)
  // or strip cookies on navigation through accounts.shopify.com.
  var urlParams = new URLSearchParams(window.location.search);
  var scaRef = urlParams.get('sca_ref');
  if (scaRef) {
    var expires = new Date();
    expires.setDate(expires.getDate() + 30);
    document.cookie =
      STORAGE_KEY + '=' +
      encodeURIComponent(scaRef) +
      '; expires=' +
      expires.toUTCString() +
      '; path=/; SameSite=Lax; Secure';
    try { localStorage.setItem(STORAGE_KEY, scaRef); } catch (e) {}
  }

  // Step 2: Classify visitor by referral state.
  // B2B and affiliated are fully resolved server-side — nothing to add.
  var body = document.body;
  if (
    body.classList.contains('customer-b2b') ||
    body.classList.contains('customer-affiliated')
  ) {
    return;
  }

  var hasCookie = document.cookie.split(';').some(function (c) {
    return c.trim().indexOf(STORAGE_KEY + '=') === 0;
  });
  var hasStorage = false;
  try { hasStorage = !!localStorage.getItem(STORAGE_KEY); } catch (e) {}

  if (!body.classList.contains('customer-logged-in')) {
    // Guest with referral cookie — mark referred per Section 2.2.
    // body.customer-guest CSS rules still block purchase; this class is
    // informational so the referral is acknowledged before login.
    if (hasCookie || hasStorage) body.classList.add('customer-referred');
    return;
  }

  // Logged-in, unclassified — cookie determines access.
  body.classList.add((hasCookie || hasStorage) ? 'customer-referred' : 'customer-gated');
})();
